import { useEffect, useRef } from "react";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";

//Just for the record, this is the halt pop up for appointments.
const ExternalEventsAvailabilityModal = () => {
  const { language } = useLanguage();
  const modalRef = useRef(null);
  const copy = translations.EventsPortal.externalEventsAvailability;

  useEffect(() => {
    modalRef.current?.focus();
  }, []);

  return (
    <div className="external-events-gate" role="presentation">
      <div
        ref={modalRef}
        className="external-events-gate__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="external-events-gate-title"
        aria-describedby="external-events-gate-message"
        tabIndex="-1"
      >
        <div className="external-events-gate__icon" aria-hidden="true">
          <i className="bi bi-calendar-event"></i>
        </div>
        <h2 id="external-events-gate-title">{copy.title[language]}</h2>
        <p id="external-events-gate-message">{copy.message[language]}</p>
        <button
          type="button"
          className="btn btn-primary external-events-gate__back"
          onClick={() => window.history.back()}
        >
          <i className="bi bi-arrow-left" aria-hidden="true"></i>
          {copy.backButton[language]}
        </button>
      </div>
    </div>
  );
};

export default ExternalEventsAvailabilityModal;
